import React, { useState } from "react";
import FormDialog from "./FormDialog";

export default function ReasonDialog({ title, label, confirm, dismiss, onClose, onConfirm }) {
  const [text, setText] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);
  const submit = async () => {
    if (!text.trim()) return;
    setSaving(true);
    setError("");
    try {
      await onConfirm(text.trim());
    } catch (err) {
      setError(err.message || "Request failed");
      setSaving(false);
    }
  };
  return (
    <FormDialog
      title={title}
      onClose={onClose}
      onSubmit={(event) => { event.preventDefault(); submit(); }}
      footer={(
        <>
          <button type="button" className="btn btn-outline-secondary" onClick={onClose}>{dismiss}</button>
          <button type="submit" className="btn btn-danger" disabled={!text.trim() || saving}>{saving ? "Saving…" : confirm}</button>
        </>
      )}
    >
      {error ? <div className="accounts-error" role="alert">{error}</div> : null}
      <label className="tally-field">{label}
        <textarea className="form-control" rows={3} maxLength={500} value={text} placeholder="Why this is being cancelled" onChange={(event) => setText(event.target.value)} />
        <span className="accounts-hint">{text.length}/500</span>
      </label>
    </FormDialog>
  );
}
